import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_timer_component = _resolveComponent("timer-component")
  const _component_base_badge = _resolveComponent("base-badge")

  return (_openBlock(), _createBlock(_component_base_badge, {
    theme: $props.theme,
    "data-qa": "countdown-badge"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.Resources.Layout.EndingInLabel) + " ", 1 /* TEXT */),
      _createVNode(_component_timer_component, {
        tag: "span",
        timestamp: $props.campaignEnd,
        "data-qa": "timer-component"
      }, {
        default: _withCtx(({ seconds, minutes }) => [
          _createTextVNode(_toDisplayString(minutes) + ":" + _toDisplayString(seconds), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["timestamp"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["theme"]))
}